import { SR_API_ACTION_UTILITY_ACTIVATION_GET_INTERNET_PLANS } from 'api/utilityActionTypes';

export default async function getInternetPlans(
  { state, utilityApiClient },
  { utilityPartnerAddressId, forceRefresh = false },
) {
  const statePath = [
    'utilityProviders',
    'internetPlansByPartnerAddressId',
    utilityPartnerAddressId,
  ];
  if (state.get(statePath) && !forceRefresh) {
    return state.get(statePath);
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_ACTIVATION_GET_INTERNET_PLANS,
    state: state,
    queryId: utilityPartnerAddressId,
    payload: {
      utilityPartnerAddressId,
    },
    onSuccess(internetPlans) {
      state.set(statePath, internetPlans);
    },
  });
}
